import { ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'
//
import global from 'common'

import { ACHDetails } from 'core/application/adminDashboard/companySettings/subscription/subscriptionDetails'
import updatePaymentInformation from 'core/application/adminDashboard/companySettings/subscription/upatePaymentInformation'

import notification from 'common/components/feedback/Notification'
import Button from 'common/components/general/Button'

import { commandRequest } from 'common/RequestUtils'
import { getAchToken } from 'common/recultyUtils'

import SubscriptionDetail from '../../components/SubscriptionDetail'
import AchForm, { ACHFormValues } from './AchForm'

interface ACHProps extends ACHDetails {
  onDataSave: () => void
  children?: ReactNode
}

const getEmptyACHValues = (): ACHFormValues => {
  return {
    agreeTerms: false,
    bankAccountType: '',
    bankRoutingNumber: '',
    accountNumberConfirmation: '',
    accountNumber: '',
    billingEmail: '',
    nameOnAccount: '',
  }
}

const ACH = ({ accountNumber, accountType, bankRoutingNumber, children, nameOnAccount, onDataSave }: ACHProps) => {
  const { t: translate } = useTranslation()
  const { isXs } = global.hooks.useBreakPoints()

  const [editMode, setEditMode] = useState<boolean>(false)

  const [loding, setLoading] = useState(false)
  const [achReculryErrors, setAchReculryErrors] = useState<Map<string, string>>(new Map())

  const onSave = (values: ACHFormValues) => {
    handleAchPayment(values)
  }

  const handleAchPayment = async (achPaymentValues: ACHFormValues) => {
    return new Promise<void>(async (resolve, reject) => {
      setLoading(true)

      try {
        const token = await getAchToken(achPaymentValues)

        const result = await commandRequest(() =>
          updatePaymentInformation({
            recurlyToken: token,
          }),
        )

        if (result.errors) {
          notification.open({
            message: translate('admin-signup.subscription.errors.went-wrong-message'),
            description: translate('admin-signup.subscription.errors.connection-error'),
            type: 'error',
          })

          setEditMode(false)
          onDataSave()
          return
        }
        setLoading(false)
        setEditMode(false)
        onDataSave()

        resolve()
      } catch (errors) {
        setAchReculryErrors(errors)
        setLoading(false)

        reject()
      }
    })
  }

  return editMode ? (
    <div>
      <AchForm onSave={onSave} recurlyErrors={achReculryErrors} onCancel={() => setEditMode(false)} />
    </div>
  ) : (
    <Row>
      <Col xs={24} sm={20}>
        <div>
          <SubscriptionDetail
            title={translate('admin-dashboard.company-settings.subscription.payment-method')}
            description={translate('admin-dashboard.company-settings.subscription.ach')}
          />
        </div>

        <Row gutter={24}>
          <Col span={12}>
            <SubscriptionDetail
              title={translate('admin-dashboard.company-settings.subscription.accunt-type')}
              description={accountType}
            />
          </Col>
          <Col span={12}>
            <SubscriptionDetail
              title={translate('admin-dashboard.company-settings.subscription.bank-routing-number')}
              description={bankRoutingNumber}
            />
          </Col>
          <Col span={12}>
            <SubscriptionDetail
              title={translate('admin-dashboard.company-settings.subscription.account-number')}
              description={accountNumber}
            />
          </Col>
          <Col span={12}>
            <SubscriptionDetail
              title={translate('admin-dashboard.company-settings.subscription.name-on-account')}
              description={nameOnAccount}
            />
          </Col>
        </Row>
      </Col>
      <Col xs={24} sm={4} className={`flex ${isXs ? 'mb-16' : 'justify-end align-end mb-16'}`}>
        <Button
          type="primary"
          icon={'far fa-pen'}
          onClick={() => {
            setEditMode(!editMode)
          }}
        >
          {translate('general.edit')}
        </Button>
      </Col>
    </Row>
  )
}

export default ACH
